import { Container, Row, Col } from 'react-bootstrap';

const EcoStp = () => {
  return (
    <Container className="mt-4 ps-0 pe-0">
      <Row>
        <Col>
          <h4>ECO STP</h4>
          <p>
            At the time of handover, Aparna provided septic tanks for sewage
            management in the community. While this system served its purpose
            initially, it became evident over time that it was not a sustainable
            solution. The septic tanks required frequent cleaning and were not
            designed to handle the growing number of residents effectively.
          </p>
          <p>
            To address this, the community decided to implement a more efficient
            and eco-friendly solution — a Sewage Treatment Plant (STP). After
            evaluating various options, the ECO STP method was selected for its
            low maintenance, cost-effectiveness, and suitability for large-scale
            residential use.
          </p>
          <p>
            Currently, as part of Phase 1, one of the existing septic tanks is
            being converted into a functional ECO STP unit. Once this phase is
            completed and operational, the solution will be extended to the
            remaining phases and septic tanks across the community.
          </p>
          <p>
            This upgrade is a crucial step toward ensuring better hygiene,
            reduced maintenance costs, and a more sustainable wastewater
            management system for all residents.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default EcoStp;
